import dayjs, { Dayjs } from 'dayjs'
import moment from 'moment'
import { getDeclination } from 'shared/utils/getDeclination'

const DAY_MS = 24 * 60 * 60 * 1000
// Бэкенд хранит «Дату окончания» концом дня по Москве — дату берём московскую
const MOSCOW_OFFSET_MINUTES = 180

const toMoscowDay = (value: string) => moment(value).utcOffset(MOSCOW_OFFSET_MINUTES)

export const formatEndDate = (value?: string | null) => (value ? toMoscowDay(value).format('DD.MM.YYYY') : '—')

// Сегодняшний день считается целым: срок до конца сегодня — «Ост. 1 день»
export const formatEndDateLeft = (value?: string | null) => {
  if (!value) return null
  const left = new Date(value).getTime() - Date.now()
  if (left <= 0) return 'Срок истёк'
  const days = Math.ceil(left / DAY_MS)
  if (days < 365) return `Ост. ${days} ${getDeclination(days % 100, ['дней', 'день', 'дня'])}`
  const years = Math.floor(days / 365)
  return `Ост. ${years} ${getDeclination(years % 100, ['лет', 'год', 'года'])}`
}

export const toEndDateField = (value?: string | null) => (value ? dayjs(toMoscowDay(value).format('YYYY-MM-DD')) : null)

export const fromEndDateField = (value?: Dayjs | null) => (value ? value.format('YYYY-MM-DD') : undefined)
